import { Store } from '../../../store/list/types';

export const closeSaveSegmentModal = (store: Store): void => {
  const { setEditedSegment } = store.getState();

  setEditedSegment(null);
};
